import React from 'react';

import { NavLink } from 'react-router-dom';

export default () => (
  <div className="navigation">
    <ul>
      <li>
        <NavLink to="/" exact activeClassName="active">
          <i className="md-icon">dashboard</i> <span>Dashboard</span>
        </NavLink>
      </li>

      <li>
        <NavLink to="/vehicles" activeClassName="active">
          <i className="md-icon">grid_on</i> <span>Programação de Veículos</span>
        </NavLink>
      </li>

      <li>
        <NavLink to="/drivers/dashboard" activeClassName="active">
          <i className="md-icon">dashboard</i> <span>Dashboard de Motoristas</span>
        </NavLink>
      </li>

      <li>
        <NavLink to="/drivers" activeClassName="active">
          <i className="md-icon">people_outline</i> <span>Motoristas</span>
        </NavLink>
      </li>

      <li>
        <NavLink to="/fleets" activeClassName="active">
          <i className="md-icon">group_work</i> <span>Frotas</span>
        </NavLink>
      </li>

    </ul>

    {/*
    <strong>Outras Ferramentas</strong>

    <ul>
      <li>
        <NavLink to="/tasks" activeClassName="active">
          <i className="md-icon">done_all</i> <span>Tarefas</span>
        </NavLink>
      </li>
    </ul>

    <strong>Manutenção</strong>

    <ul>
      <li>
        <NavLink to="/management/vehicles" activeClassName="active">
          <i className="md-icon">local_shipping</i> <span>Veículos</span>
        </NavLink>
      </li>

      <li>
        <NavLink to="/management/drivers" activeClassName="active">
          <i className="md-icon">people</i> <span>Motoristas</span>
        </NavLink>
      </li>
    </ul>
    */}
  </div>
);



// WEBPACK FOOTER //
// ./src/Shared/Helpers/Navigation.js